
// frontend/src/components/LoginPage/LoginPage.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { getCurrentUser } from "../api/auth";
import { getRoleFromGroups } from "../../config/roles";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;


function LoginPage({ setUser }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      alert("Введите логин и пароль");
      return;
    }

    setLoading(true);


    try {
      // =====================================================
      // 1. LOGIN
      // =====================================================

      const response = await fetch(
        `${BASE_URL}/api/token/`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            username,
            password,
          }),
        }
      );


      // =====================================================
      // 2. LOGIN ERROR
      // =====================================================

      if (!response.ok) {
        alert("Неверный логин или пароль");
        return;
      }


      // =====================================================
      // 3. JWT
      // =====================================================

      const data = await response.json();


      if (!data.access || !data.refresh) {
        console.error(
          "[LOGIN] JWT tokens отсутствуют:",
          data
        );

        alert("Ошибка авторизации: сервер не вернул токены");
        return;
      }


      // =====================================================
      // 4. SAVE TOKENS
      // =====================================================

      localStorage.setItem(
        "access_token",
        data.access
      );

      localStorage.setItem(
        "refresh_token",
        data.refresh
      );

      localStorage.setItem(
        "username",
        username
      );


      console.log(
        "[LOGIN] JWT получен"
      );


      // =====================================================
      // 5. GET CURRENT USER
      // =====================================================
      //
      // ВАЖНО:
      //
      // Нельзя делать:
      //
      // setUser({
      //   name: username
      // });
      //
      // потому что там нет groups.
      //
      // После логина получаем пользователя
      // через API вместе с его группами.
      //

      const currentUser = await getCurrentUser();


      if (!currentUser) {
        console.error(
          "[LOGIN] Не удалось получить текущего пользователя"
        );

        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("username");

        alert(
          "Авторизация прошла, но данные пользователя получить не удалось"
        );

        return;
      }


      // =====================================================
      // 6. USER GROUPS
      // =====================================================

      const groups = Array.isArray(
        currentUser.groups
      )
        ? currentUser.groups
        : [];


      console.log(
        "[LOGIN] CURRENT USER:",
        currentUser
      );

      console.log(
        "[LOGIN] GROUPS:",
        groups
      );


      // =====================================================
      // 7. DETERMINE ROLE
      // =====================================================

      const currentRole =
        getRoleFromGroups(groups);


      console.log(
        "[LOGIN] ROLE:",
        currentRole
      );


      if (!currentRole) {
        console.error(
          "[LOGIN] Для пользователя не найдена роль"
        );

        console.error(
          "[LOGIN] Groups:",
          groups
        );

        alert(
          "Для этого пользователя не назначена роль"
        );

        return;
      }


      // =====================================================
      // 8. NORMALIZE USER
      // =====================================================

      const normalizedUser = {
        id: currentUser.id,

        name: currentUser.username,

        username: currentUser.username,

        groups: groups,

        avatar:
          "https://i.pravatar.cc/150?img=3",
      };


      console.log(
        "[LOGIN] NORMALIZED USER:",
        normalizedUser
      );


      // =====================================================
      // 9. SET USER IN APP
      // =====================================================

      setUser(normalizedUser);


      // =====================================================
      // 10. REDIRECT TO ROLE DEFAULT PAGE
      // =====================================================

      console.log(
        `[LOGIN] Redirect → ${currentRole.defaultPath}`
      );


      navigate(
        currentRole.defaultPath,
        {
          replace: true,
        }
      );


    } catch (error) {

      console.error(
        "[LOGIN] Ошибка:",
        error
      );

      alert(
        "Ошибка при подключении к серверу"
      );

    } finally {

      setLoading(false);

    }
  };


  // =========================================================
  // UI
  // =========================================================

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gray-100">

      <form
        onSubmit={handleLogin}
        className="bg-white p-8 rounded shadow-md flex flex-col gap-4 w-80"
      >

        <h2 className="text-2xl font-bold text-center">
          Вход
        </h2>


        {/* USERNAME */}

        <input
          type="text"
          placeholder="Имя пользователя"

          value={username}

          onChange={(e) =>
            setUsername(e.target.value)
          }

          disabled={loading}

          className="border p-2 rounded"
        />


        {/* PASSWORD */}

        <input
          type="password"
          placeholder="Пароль"

          value={password}

          onChange={(e) =>
            setPassword(e.target.value)
          }

          disabled={loading}

          className="border p-2 rounded"
        />


        {/* LOGIN BUTTON */}

        <button
          type="submit"

          disabled={loading}

          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 transition disabled:opacity-50"
        >
          {loading
            ? "Загрузка..."
            : "Войти"}
        </button>

      </form>

    </div>
  );
}

export default LoginPage;